var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/direct"
  }, /*#__PURE__*/React.createElement("g", {
    id: "direct"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.975 9.17188H13.365C12.63 9.17188 11.9775 9.57688 11.6475 10.2369L11.0175 11.4819C10.8675 11.7819 10.5675 11.9694 10.2375 11.9694H7.7775C7.545 11.9694 7.215 11.9169 6.9975 11.4819L6.3675 10.2444C6.0375 9.59188 5.3775 9.17938 4.65 9.17938H2.025C1.7325 9.17938 1.5 9.41188 1.5 9.70438V12.1494C1.5 14.8719 3.135 16.4994 5.865 16.4994H12.15C14.7225 16.4994 16.305 15.0894 16.5 12.5844V9.69688C16.5 9.41188 16.2675 9.17188 15.975 9.17188Z",
    fill: "#57A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V8.1375C1.665 8.0775 1.845 8.0475 2.025 8.0475H4.65C5.8125 8.0475 6.855 8.6925 7.3725 9.735L7.935 10.8375H10.08L10.6425 9.7275C11.16 8.6925 12.2025 8.0475 13.365 8.0475H15.975C16.155 8.0475 16.335 8.0775 16.5 8.1375V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM7.8375 4.0575H10.1625C10.4475 4.0575 10.6875 4.29 10.6875 4.575C10.6875 4.8675 10.4475 5.1 10.1625 5.1H7.8375C7.5525 5.1 7.3125 4.8675 7.3125 4.575C7.3125 4.29 7.5525 4.0575 7.8375 4.0575ZM10.7475 7.1925H7.2525C6.9675 7.1925 6.735 6.96 6.735 6.675C6.735 6.3825 6.9675 6.15 7.2525 6.15H10.7475C11.0325 6.15 11.265 6.3825 11.265 6.675C11.265 6.96 11.0325 7.1925 10.7475 7.1925Z",
    fill: "#57A6BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.2f9a0e5e3d3a77dd6d05468c54a892bc.svg";
export { ForwardRef as ReactComponent };